export default "__VITE_ASSET__B5qr_XD$__"